export default {
  "invite": {
    "title": "Paybet میں خوش آمدید",
    "tab1": "ای میل",
    "tab2": "موبائل",
    "formPh1": "ای میل ایڈریس درج کریں",
    "formPh5": "موبائل نمبر درج کریں",
    "formPh2": "لاگ ان پاس ورڈ سیٹ کریں",
    "formPh3": "لاگ ان پاس ورڈ دوبارہ درج کریں",
    "formPh4": "تصدیقی کوڈ درج کریں",
    "btnTxt1": "کوڈ حاصل کریں",
    "btnTxt2": "رجسٹر کریں",
    "successTxt1": "Paybet رجسٹریشن کامیاب",
    "successTxt2": "ڈاؤن لوڈ",
    "errorTxt1": "موبائل نمبر کی شکل غلط",
    "errorTxt2": "ای میل کی شکل غلط",
    "errorTxt3": "موبائل نمبر پہلے سے رجسٹرڈ",
    "errorTxt4": "ای میل ایڈریس پہلے سے رجسٹرڈ",
    "errorTxt5": "تصدیقی کوڈ غلط یا ختم",
    "errorTxt6": "پاس ورڈ مماثل نہیں",
    "errorTxt7": "پاس ورڈ 8 حروف سے زیادہ ہونا چاہیے",
    "errorTxt8": "پاس ورڈ میں کم از کم 1 نمبر ہونا چاہیے",
    "errorTxt9": "پاس ورڈ میں کم از کم 1 حرف ہونا چاہیے"
    ,"countryNotAllowed": "آپ کے ملک میں رجسٹریشن کی اجازت نہیں"
  },
  "Sort_Picker_title": "براہ کرم اپنا بین الاقوامی کوڈ منتخب کریں",
  "ReconfirmModalText1": "سیکورٹی تصدیق",
  "verifySuccess": "تصدیق کامیاب",
  "verifyError": "تصدیق ناکام، دوبارہ کوشش کریں",
  "sliderText": "دائیں طرف سلائیڈ کرکے تصدیق مکمل کریں",
  "download": {
    "title": "فوراً کمانا شروع کریں!",
    "subtitle": "ابھی PayBet ڈاؤن لوڈ کریں!",
    "tagline": "محفوظ | آسان | منافع بخش",
    "downloadBtn": "ابھی PayBet ایپ ڈاؤن لوڈ کریں",
    "whyChoose": "PayBet کیوں منتخب کریں؟",
    "feature1Title": "تیز لین دین",
    "feature1Desc": "فوری جمع اور نکالنے کی سہولت",
    "feature2Title": "آسان آمدنی",
    "feature2Desc": "ہر خرید و فروخت پر آسانی سے کمیشن کمائیں",
    "feature3Title": "محفوظ اور قابلِ اعتماد",
    "feature3Desc": "بینک سطح کی انکرپشن کے ساتھ تیار کیا گیا",
    "feature4Title": "استعمال میں آسان",
    "feature4Desc": "پیٹنٹ شدہ ٹیکنالوجی کے ساتھ خودکار موڈ",
    "stepsTitle": "کمانا شروع کرنے کے 3 مراحل",
    "step1Title": "PayBet ایپ ڈاؤن لوڈ کریں اور انسٹال کریں",
    "step2Title": "رجسٹر کریں اور اپنا UPI / بینک کارڈ لنک کریں",
    "step3Title": "جمع کرنا، نکالنا اور کمیشن کمانا شروع کریں",
    "bottomText": "PayBet ایپ کے اندر مزید نقد انعامات اور بونس دریافت کریں!",
    "copyright": "© 2025 PayBet۔ جملہ حقوق محفوظ ہیں۔"
  },
   inviteJt: {
    title: 'JTPay میں خوش آمدید',
    successTxt1: "JTPay رجسٹریشن کامیاب",
    successTxt2: "JTpay APP",
  },
}
